import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";

const state = {
    holidays: [],
    suggestions: [],
};

const mutations = {
    setHolidays: (state, r) => (state.holidays = r),
    setSuggestions: (state, r) => (state.suggestions = r),
};

// Same shape as the other modules: loader, statusCode check, success snackbar for
// writes, catchHandler for errors (it shows the server's Arabic message).
async function call(request, { notify = false } = {}) {
    try {
        startLoading();
        const response = await request();
        stopLoading();

        if (!response.data.statusCode) {
            showAlert(serverErrorMessage);
            return Promise.reject(new Error("statusCode"));
        }

        if (notify) showNotification(response.data.message);
        return response.data;
    } catch (error) {
        stopLoading();
        if (error.message !== "statusCode") catchHandler(error);
        return Promise.reject(error);
    }
}

const actions = {
    async getAll({ commit }, year) {
        const data = await call(() => dataService.holidays.getAll(`year=${year}`)).catch(() => null);
        if (data) commit("setHolidays", data.holidays);
    },
    async getSuggestions({ commit }, year) {
        const data = await call(() => dataService.holidays.bridgeSuggestions(year)).catch(() => null);
        commit("setSuggestions", data ? data.suggestions : []);
    },
    get: (_, id) => call(() => dataService.holidays.get(id)).then(d => d.holiday),
    add: (_, payload) => call(() => dataService.holidays.add(payload), { notify: true }),
    edit: (_, { id, payload }) => call(() => dataService.holidays.edit(id, payload), { notify: true }),
    delete: (_, id) => call(() => dataService.holidays.delete(id), { notify: true }),
    // Returns the full result (charged, skipped, warnings) for the result dialog.
    apply: (_, id) => call(() => dataService.holidays.apply(id), { notify: true }),
    reverse: (_, id) => call(() => dataService.holidays.reverse(id), { notify: true }),
    deductions: (_, id) => call(() => dataService.holidays.deductions(id)).then(d => d.deductions),
    convertAbsences: (_, payload) => call(() => dataService.holidays.convertAbsences(payload), { notify: true }),
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
